import { ComponentType, createContext, LazyExoticComponent } from "react";

export type StepType = {
  component: LazyExoticComponent<ComponentType<any>>;
};

type AppContextType = {
  steps: StepType[];
  current: {
    index: number;
    step: StepType;
  };
  state: Record<string, any>;
  progress: number;
  go: (index: number) => void;
  updateState: (key: string, value: any) => void;
};

export const AppContext = createContext({} as AppContextType);
